const namespace = 'com.mymoodbit.redux:';
export default namespace;
